import { Checkbox } from '../../Checkbox';
import { FieldProps } from './FieldProps';

export function ConsentForExternalEvents(props: FieldProps) {
  const { className, isSendingStatus, sendFormFillAnalytics } = props;

  const label = `Я ознакомлен(а) и согласен(а) с <a target="_blank" href="https://cdn.cloud.ru/docs/legal/security/cybersecurity-pd/events-participation-consent.pdf">правилами поведения</a> участников на мероприятии`;

  return (
    <div className={className}>
      <Checkbox
        label={label}
        value="true"
        name="event_participation_rules_consent"
        required
        disabled={isSendingStatus}
        onChange={(checked) => {
          if (checked) {
            sendFormFillAnalytics('checkbox consentForExternalEvents');
          }
        }}
      />
    </div>
  );
}
